import React, { useEffect, useRef, useState } from "react";
import { SetState } from "shared/types/general";
import s from "./style.module.scss";
import { IMallItem } from "shared/types/malls";
import Logo from "shared/icons/Logo";
import ArrowDown from "widgets/Header/icons/ArrowDown";

interface Props {
  value: IMallItem | undefined;
  setValue: SetState<IMallItem | undefined>;
  malls: IMallItem[];
}

export const MallSelect: React.FC<Props> = ({ setValue, value, malls }) => {
  const [open, setOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => setOpen((prev) => !prev);

  const handleChange = (item: IMallItem) => {
    setValue(item);
  };

  useEffect(() => {
    if (selectRef.current) {
      const closeMenu = (e: React.MouseEvent<HTMLElement>) => {
        //@ts-ignore
        if (!selectRef.current?.contains(e.target)) {
          setOpen(false);
        }
      };

      //@ts-ignore
      document?.body.addEventListener("click", closeMenu);
      //@ts-ignore
      return () => document?.body.removeEventListener("click", closeMenu);
    }
  }, [selectRef]);

  return (
    <div className={s.select} ref={selectRef} onClick={toggleOpen}>
      <div className={s.header}>
        <Logo />{" "}
        <div>
          <span>Место встречи:</span> {value?.title || ""}
        </div>{" "}
        <ArrowDown />
      </div>

      <ul className={`${s.list} ${open ? s.open : ""}`}>
        {malls.map((item) => (
          <li
            className={s.item}
            key={item.id}
            onClick={() => handleChange(item)}
          >
            {item.title}
          </li>
        ))}
      </ul>
    </div>
  );
};
